import type {
  CreateGuideInput,
  CreateStepInput,
  Guide,
  GuideRevision,
  GuideStep,
  GuideWithSteps,
  UpdateGuideInput,
  UpdateStepInput,
} from "@shared/modules/guides";
import { api } from "../../../core/lib/api";

// Appels typés du module : une fonction par route de l'API.
export const guidesApi = {
  list: () => api<Guide[]>("/api/guides"),
  get: (id: string) => api<GuideWithSteps>(`/api/guides/${id}`),
  /** Lecture par slug, session facultative (lecteur public et lecteur du shell). */
  bySlug: (slug: string) => api<GuideWithSteps>(`/api/guides/public/${encodeURIComponent(slug)}`),
  create: (input: CreateGuideInput) => api<Guide>("/api/guides", { method: "POST", body: JSON.stringify(input) }),
  update: (id: string, input: UpdateGuideInput) =>
    api<Guide>(`/api/guides/${id}`, { method: "PATCH", body: JSON.stringify(input) }),
  remove: (id: string) => api<void>(`/api/guides/${id}`, { method: "DELETE" }),
  publish: (id: string) => api<GuideWithSteps>(`/api/guides/${id}/publish`, { method: "POST" }),
  revisions: (id: string) => api<GuideRevision[]>(`/api/guides/${id}/revisions`),
  createStep: (guideId: string, input: CreateStepInput) =>
    api<GuideStep>(`/api/guides/${guideId}/steps`, { method: "POST", body: JSON.stringify(input) }),
  updateStep: (guideId: string, stepId: string, input: UpdateStepInput) =>
    api<GuideStep>(`/api/guides/${guideId}/steps/${stepId}`, { method: "PATCH", body: JSON.stringify(input) }),
  deleteStep: (guideId: string, stepId: string) =>
    api<void>(`/api/guides/${guideId}/steps/${stepId}`, { method: "DELETE" }),
  orderSteps: (guideId: string, ids: string[]) =>
    api<GuideStep[]>(`/api/guides/${guideId}/steps/order`, { method: "PUT", body: JSON.stringify({ ids }) }),
};

/** Adresse publique d'un guide (à partager hors connexion si sa visibilité le permet). */
export function publicGuideUrl(slug: string): string {
  return `${window.location.origin}/g/${slug}`;
}
